/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SwapScreenerLeadResidents200ResponseDataLead1
 */
export interface SwapScreenerLeadResidents200ResponseDataLead1 {
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    new_bed_id?: string;
}

/**
 * Check if a given object implements the SwapScreenerLeadResidents200ResponseDataLead1 interface.
 */
export function instanceOfSwapScreenerLeadResidents200ResponseDataLead1(value: object): value is SwapScreenerLeadResidents200ResponseDataLead1 {
    return true;
}

export function SwapScreenerLeadResidents200ResponseDataLead1FromJSON(json: any): SwapScreenerLeadResidents200ResponseDataLead1 {
    return SwapScreenerLeadResidents200ResponseDataLead1FromJSONTyped(json, false);
}

export function SwapScreenerLeadResidents200ResponseDataLead1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SwapScreenerLeadResidents200ResponseDataLead1 {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'new_bed_id': json['new_bed_id'] == null ? undefined : json['new_bed_id'],
    };
}

export function SwapScreenerLeadResidents200ResponseDataLead1ToJSON(json: any): SwapScreenerLeadResidents200ResponseDataLead1 {
    return SwapScreenerLeadResidents200ResponseDataLead1ToJSONTyped(json, false);
}

export function SwapScreenerLeadResidents200ResponseDataLead1ToJSONTyped(value?: SwapScreenerLeadResidents200ResponseDataLead1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'new_bed_id': value['new_bed_id'],
    };
}

